import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { CompassOutlined } from "@ant-design/icons";

/**
 * Catch-all 404 — rendered by App.tsx's wildcard route (`path="*"`) for any
 * URL that doesn't match a real route, instead of silently redirecting
 * elsewhere. Deliberately standalone (no MainLayout/TenderContext dependency)
 * since an unmatched route may be hit before any tender/project context
 * exists — same convention as the "Access Denied"/"Almost There" access-gate
 * cards in App.tsx, which this mirrors visually.
 */
const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-full min-h-screen items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-4 bg-white rounded-xl shadow-lg p-10 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full mx-auto mb-6">
          <CompassOutlined style={{ fontSize: 28, color: "#3b82f6" }} />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-sm text-gray-600 mb-6 leading-relaxed">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Button type="primary" onClick={() => navigate("/")} size="large">
          Return to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
